var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4H2V3h3v1zm10.93 0l.812 1.219A3.99 3.99 0 0020.07 7H22v13H2V7h3.93a3.99 3.99 0 003.328-1.781L10.07 4h5.86zM17 2H9L7.594 4.109A1.998 1.998 0 015.93 5H0v17h24V5h-3.93a1.998 1.998 0 01-1.664-.891L17 2zM6 10a1 1 0 10-2 0 1 1 0 002 0zm7 0c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0-2a5 5 0 10.001 10.001A5 5 0 0013 8z"
  })));
}
export default SvgCamera;